import React, {useEffect, useState} from 'react'
import {useDispatch} from 'react-redux'
import {changeModalVisibility} from '../../../../../setup/slices/ModalSlice'
import {client} from '../../../../ApolloClient/client'
import {getActivityCallHistory} from '../../../../helper/ActivityHelper'

interface Props {
  emptyActivity: any
  setFormValues: any
  composeActivity: any
  setCallHistory: any
  typeGuid: string
  customer: any
}

const CallAgain: React.FC<Props> = ({
  emptyActivity,
  setFormValues,
  composeActivity,
  setCallHistory,
  typeGuid,
  customer,
}) => {
  const [callDate, setCallDate] = useState<string>()
  const [expText, setExpText] = useState<string>()
  const [buttonDisabled, setButtonDisabled] = useState<boolean>(false)

  const dispatch = useDispatch()

  const handleSubmit = (event: any) => {
    event.preventDefault()
    composeActivity(customer)
    getActivityCallHistory(5, typeGuid, client, setCallHistory, customer.CustomerId)
    setButtonDisabled(true)

    setTimeout(() => {
      dispatch(changeModalVisibility(false))
      setButtonDisabled(false)
    }, 1000)
  }

  useEffect(() => {
    setFormValues([])
  }, [])
  useEffect(() => {
    setFormValues([
      '',
      expText,
      callDate,
      emptyActivity.activityStatements[4].jsonValues.items[2].option,
      '',
      '',
      '',
      '',
    ])
  }, [callDate, expText])

  return (
    <form className='row' onSubmit={(event) => handleSubmit(event)}>
      <div className='row'>
        <div className='row'>
          <div className='col-2'></div>
          <label className='col-4 fw-bolder fs-6' style={{alignSelf: 'center'}} htmlFor='date'>
            {emptyActivity.activityStatements[3].statementText}:
          </label>
          <div className='col-5 ms-3'>
            <div className='form-group'>
              <input
                className='form-control'
                id='date'
                name='date'
                type='date'
                min={'1900-01-01'}
                max={'2100-12-31'}
                onChange={(e) => setCallDate(e.target.value)}
                required
              />
            </div>
          </div>
        </div>
      </div>

      <div className='row mt-4'>
        <div className='col-2'></div>
        <label
          className='col-4 fw-bolder fs-6 pt-4'
          style={{alignSelf: 'center'}}
          htmlFor='explanationText'
        >
          {emptyActivity.activityStatements[2].statementText}:
        </label>
        <div className='col-5 '>
          <textarea
            className='form-control'
            id='explanationText'
            rows={4}
            onChange={(e) => setExpText(e.target.value)}
          ></textarea>
        </div>
      </div>
      <div className='col-md-11 d-flex justify-content-end mt-4'>
        <div className='w-90 me-5'>
          <button type='submit' className='btn btn-success w-100' disabled={buttonDisabled}>
            Kaydet
          </button>
        </div>
      </div>
    </form>
  )
}

export default CallAgain
